/** What a report still needs before it can be created; empty when it is ready. */
export type CreateRequirement = 'name' | 'rows' | 'columns' | 'source';

export const missingForCreate = (draft: {
  readonly name: string;
  readonly rows: number;
  readonly columns: number;
  readonly hasSource: boolean;
}): CreateRequirement[] => [
  ...(draft.name.trim() ? [] : ['name' as const]),
  ...(draft.rows > 0 ? [] : ['rows' as const]),
  ...(draft.columns > 0 ? [] : ['columns' as const]),
  ...(draft.hasSource ? [] : ['source' as const])
];
